import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiGet, apiPost, apiDelete } from '../api/client';

export default function Bloqueios() {
    const [bloqueios, setBloqueios] = useState([]);
    const [loading, setLoading]     = useState(true);
    const [form, setForm]           = useState({ data_inicio: '', data_fim: '', tipo_lote: 'todos', motivo: '' });
    const [salvando, setSalvando]   = useState(false);
    const [erro, setErro]           = useState('');

    const carregar = () => {
        setLoading(true);
        apiGet('/api/admin/bloqueios').then(res => {
            if (res?.success) setBloqueios(res.data.dados);
            setLoading(false);
        });
    };

    useEffect(() => { carregar(); }, []);

    const salvar = async () => {
        setErro('');
        if (!form.data_inicio || !form.data_fim) {
            setErro('Preencha as datas.');
            return;
        }
        setSalvando(true);
        const res = await apiPost('/api/admin/bloqueios', form);
        if (res?.success) {
            setForm({ data_inicio: '', data_fim: '', tipo_lote: 'todos', motivo: '' });
            carregar();
        } else {
            setErro(res?.errors?.[0] || 'Erro ao salvar.');
        }
        setSalvando(false);
    };

    const remover = async (id) => {
        if (!window.confirm('Remover este bloqueio?')) return;
        const res = await apiDelete(`/api/admin/bloqueios/${id}`);
        if (res?.success) carregar();
    };

    return (
        <Layout>
            <h1 style={{ margin: '0 0 24px', fontSize: '24px', color: '#1B2631' }}>Bloqueios de agenda</h1>

            {/* Formulário */}
            <div style={{ background: '#fff', borderRadius: '10px', padding: '24px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <h2 style={{ margin: '0 0 16px', fontSize: '16px', color: '#2C3E50' }}>Novo bloqueio</h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 2fr', gap: '12px', alignItems: 'end' }}>
                    <div>
                        <label style={label}>Data início</label>
                        <input type="date" value={form.data_inicio}
                            onChange={e => setForm(f => ({...f, data_inicio: e.target.value}))}
                            style={input} />
                    </div>
                    <div>
                        <label style={label}>Data fim</label>
                        <input type="date" value={form.data_fim}
                            onChange={e => setForm(f => ({...f, data_fim: e.target.value}))}
                            style={input} />
                    </div>
                    <div>
                        <label style={label}>Tipo</label>
                        <select value={form.tipo_lote}
                            onChange={e => setForm(f => ({...f, tipo_lote: e.target.value}))}
                            style={input}>
                            <option value="todos">Todos</option>
                            <option value="sucata">Sucata</option>
                            <option value="conservado">Conservado</option>
                        </select>
                    </div>
                    <div>
                        <label style={label}>Motivo (opcional)</label>
                        <input type="text" value={form.motivo} maxLength={255}
                            onChange={e => setForm(f => ({...f, motivo: e.target.value}))}
                            placeholder="Ex: Feriado, manutenção..."
                            style={input} />
                    </div>
                </div>
                {erro && <div style={{ color: '#922B21', fontSize: '13px', marginTop: '10px' }}>{erro}</div>}
                <button onClick={salvar} disabled={salvando} style={{
                    marginTop: '16px', padding: '10px 24px',
                    background: salvando ? '#AED6F1' : '#1B4F72',
                    color: '#fff', border: 'none', borderRadius: '6px',
                    cursor: salvando ? 'not-allowed' : 'pointer',
                    fontWeight: '600', fontSize: '14px',
                }}>
                    {salvando ? 'Salvando...' : 'Bloquear período'}
                </button>
            </div>

            {/* Lista */}
            <div style={{ background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                {loading ? <LoadingSpinner /> : (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ background: '#F8F9FA', borderBottom: '2px solid #EAECEE' }}>
                                {['Início', 'Fim', 'Tipo', 'Motivo', 'Criado por', ''].map(h => (
                                    <th key={h} style={th}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {bloqueios.length === 0 ? (
                                <tr><td colSpan={6} style={{ textAlign: 'center', padding: '32px', color: '#95A5A6' }}>
                                    Nenhum bloqueio cadastrado.
                                </td></tr>
                            ) : bloqueios.map(b => (
                                <tr key={b.id} style={{ borderBottom: '1px solid #F0F0F0' }}>
                                    <td style={td}>{b.data_inicio}</td>
                                    <td style={td}>{b.data_fim}</td>
                                    <td style={td}>
                                        <span style={{
                                            background: '#FDEDEC', color: '#922B21',
                                            padding: '2px 8px', borderRadius: '10px',
                                            fontSize: '12px', fontWeight: '600',
                                        }}>
                                            {b.tipo_lote}
                                        </span>
                                    </td>
                                    <td style={td}>{b.motivo || '—'}</td>
                                    <td style={td}>{b.criado_por}</td>
                                    <td style={td}>
                                        <button onClick={() => remover(b.id)} style={{
                                            background: 'none', border: '1px solid #E74C3C',
                                            color: '#E74C3C', borderRadius: '6px',
                                            padding: '4px 10px', cursor: 'pointer', fontSize: '12px',
                                        }}>
                                            Remover
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </Layout>
    );
}

const label = { display: 'block', fontSize: '13px', fontWeight: '600', color: '#2C3E50', marginBottom: '5px' };
const input = { width: '100%', padding: '8px 10px', border: '1px solid #D5D8DC', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
const th = { padding: '10px 14px', textAlign: 'left', fontSize: '12px', fontWeight: '700', color: '#566573', textTransform: 'uppercase' };
const td = { padding: '12px 14px', fontSize: '14px', color: '#2C3E50' };